import {Component, Inject, OnInit} from '@angular/core';
import {FileTypeSelectComponent} from './file-type-select/file-type-select.component';
import {IDatasetFileManagerCategoryItems, IFormFileItem, IFormFileUploadDialog} from '../../../interface/form-structure';
import {AddFileComponent} from './add-file/add-file.component';
import {HttpFormService} from '../../../services/formServices';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MatBottomSheet} from '@angular/material/bottom-sheet';

@Component({
    selector: 'noos-file-manager',
    templateUrl: './file-manager.component.html',
    styleUrls: ['./file-manager.component.scss']
})
export class FileManagerComponent implements OnInit {

    isLoading = false;

    constructor(
        public dialogRef: MatDialogRef<FileManagerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IFormFileUploadDialog,
        private bottomSheet: MatBottomSheet,
        private dialog: MatDialog,
        private formService: HttpFormService
    ) {
    }

    ngOnInit() {
    }

    openFileType(): void {
        const selectFileType = this.bottomSheet.open(FileTypeSelectComponent, {
            data: this.data.fileCategoryItems,
            hasBackdrop: true,
        });
        selectFileType.afterDismissed().subscribe(ret => {
            if (ret !== undefined) {
                this.onOpenFileDialog(ret);
            }
        });
    }

    onOpenFileDialog(fileCategory: IDatasetFileManagerCategoryItems) {
        const dialogConfig = new MatDialogConfig();

        /*const dialogData: IFormFileUploadDialog = {
            fileCategoryItem: fileCategory,
            fileCategoryItems: [],
            FORM_GUID: this.data.FORM_GUID,
            FORM_ID: this.data.FORM_ID
        };*/

        this.data.fileCategoryItem = fileCategory;

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '400px';
        dialogConfig.data = {};
        dialogConfig.panelClass = 'formDialog';
        dialogConfig.data = this.data;

        const dialogRef = this.dialog.open(AddFileComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result: IFormFileUploadDialog) => {
            if (result) {
                this.data = result;
            }
        });

    }

    onCancel() {
        this.dialogRef.close();
    }

    onSaveFile() {
        this.dialogRef.close(this.data);
    }

    getFileTypeName(fileTypeId) {
        const fileType = this.data.fileCategoryItems.filter(x => x.file_category_code === fileTypeId);
        if (fileType.length > 0) {
            return fileType[0].file_category_name;
        }
        return 'Diğer';
    }

    onDeleteItem(item: IFormFileItem) {
        this.isLoading = true;
        this.formService.fileDelete(0, item.id).subscribe(ret => {
            this.isLoading = false;
            if (ret.complete) {
                const index = this.data.formFileData.indexOf(item);
                this.data.formFileData.splice(index, 1);
            }
        });

    }
}
